module.exports = __webpack_public_path__ + "img/review-success-zhans.6d07757a.png";